import React from 'react'
import HTag from '@/lib/HTag'
import CTA from '@/lib/CTA'
import Event from './Event'
import setStyle from '@/utils/setStyle'
import clsx from 'clsx'

export default function EventList({ heading, cta, events, style, pattern }) {
	return (
		<section id="events" className={clsx(setStyle(style), pattern)}>
			<div className="section">
				<HTag className="h1 text-center mb-8 mx-auto <sm:max-w-[200px]" {...heading} />
				<p className={clsx(cta && 'directional-line', 'text-center')}>
					<CTA {...cta} />
				</p>

				<ul className="carousel gap-4 mt-8">
					{events?.map((event, key) => (
						<li className="colored-list rounded-xl overflow-hidden z-10" key={key}>
							<Event {...event} />
						</li>
					))}
				</ul>
			</div>
		</section>
	)
}
